import React from 'react';
import { Box, Typography } from '@mui/material';
import type { Category, Project } from '../data/projects';
import ProjectCard from './ProjectCard';

interface ProjectGridProps {
  projects: Project[];
  /** Used only to build the images' alt text, since no captions are rendered. */
  categories: Category[];
}

/**
 * Caption-free photo gallery: a 1/2/3-column masonry (CSS columns) that keeps
 * every photo in its own aspect ratio instead of cropping to a uniform card.
 */
const ProjectGrid: React.FC<ProjectGridProps> = ({ projects, categories }) => {
  if (projects.length === 0) {
    return (
      <Typography align="center" sx={{ color: 'common.white', mt: 4 }}>
        Keine Projekte in dieser Kategorie.
      </Typography>
    );
  }

  const labels = new Map(categories.map((category) => [category.id, category.label]));

  return (
    <Box sx={{ columnCount: { xs: 1, sm: 2, md: 3 }, columnGap: 3 }}>
      {projects.map((project) => {
        const label = labels.get(project.category);
        return (
          <Box
            key={project.id}
            // Keeps a tile from being split across two columns.
            sx={{ breakInside: 'avoid', WebkitColumnBreakInside: 'avoid', mb: 3 }}
          >
            <ProjectCard
              project={project}
              alt={label ? `Projekt aus der Kategorie ${label}` : 'Projekt der Werklibuebe'}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ProjectGrid;
